
import { _post, _get, _delete } from "./Axios";

export default class GroupsApi {
  static get(id = null) {
    if (id == null) {
      return _get("users/groups/");
    } else {
      return _get("users/groups/" + id);
    }
  }
  static getByKeyword(keyword = "") {
    return _get("users/groups/?keyword=" + keyword);
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("users/groups/?" + params);
  }
  static post(data) {
    return _post("users/groups/", data);
  }
  static update(id, data) {
    return _post("users/groups/" + id, data);
  }
  static delete(id) {
    return _delete("users/groups/" + id);
  }
}
